import React from 'react';
import BarraProgresso from '../../ui/primitivos/BarraProgresso';

export type VistoriaUploadEstado = 'enviando' | 'erro' | 'concluido';

export interface VistoriaUploadProgressProps {
  /** Percentual real do trabalho concluído (0 a 100). */
  percent: number;
  /** Rótulo principal, ex.: "Enviando foto 3 de 29...". */
  rotulo: string;
  /** Estado visual da barra. */
  estado?: VistoriaUploadEstado;
  /** Linha auxiliar opcional (ex.: instrução de retry). */
  detalhe?: string;
}

/**
 * Barra de progresso de envio de fotos da vistoria.
 *
 * 🔴 **Desde a at-67 isto é um WRAPPER de compatibilidade**, não uma
 * implementação: o corpo subiu para `ui/primitivos/BarraProgresso.tsx` quando os
 * modais de sincronização de `/ti` passaram a precisar da mesma barra (o
 * "consumidor plural" que a at-63 disse faltar). O único trabalho aqui é traduzir
 * o nome do estado — `enviando` → `em-andamento`.
 *
 * ⚠️ **O wrapper existe para `/vistoria/captura` NÃO ser tocada nesta branch.**
 * Aquela tela é a mais dependente de aparelho do app (câmera, upload foto a foto,
 * retry) e foi validada na at-63; trocar o import dela aqui espalharia risco para
 * fora do escopo da at-67 sem nenhum ganho. **Quem tocar naquela tela deve trocar
 * o import por `BarraProgresso` e apagar este arquivo.**
 *
 * 📌 O progresso é **honesto** porque quem o alimenta conta as RESPOSTAS do
 * backend, não o `onUploadProgress` do axios (at-24) — foi o defeito que fazia a
 * barra chegar a 100% no primeiro segundo.
 */

const POR_ESTADO = {
  enviando: 'em-andamento',
  erro: 'erro',
  concluido: 'concluido',
} as const;

const VistoriaUploadProgress: React.FC<VistoriaUploadProgressProps> = ({
  percent,
  rotulo,
  estado = 'enviando',
  detalhe,
}) => (
  <BarraProgresso
    percent={percent}
    rotulo={rotulo}
    estado={POR_ESTADO[estado]}
    detalhe={detalhe}
  />
);

export default VistoriaUploadProgress;
